// extracted by mini-css-extract-plugin
module.exports = {"main":"maintainTip_main__bry1L"};